export default __webpack_public_path__ + "static/media/badge_research.5cf148a1.svg";